class SizeGuide extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.normalizeTableHeaders()
  }

  setupListeners () {
    super.setupListeners()

    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleSelect = this.handleSelect.bind(this)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleOpen)
    })

    this.externalEls?.close?.elements.forEach((closeEl) => {
      this.listeners.add(closeEl, 'click', this.handleClose)
    })

    if (this.externalEls?.select?.element) {
      this.listeners.add(
        this.externalEls.select.element,
        'change',
        this.handleSelect,
      )
    }
  }

  handleOpen () {
    this.externalEls.modal.element.showModal()
    document.body.classList.toggle('util-SiteOverfloewd', true)
  }

  handleClose () {
    this.externalEls.modal.element.close()
    document.body.classList.toggle('util-SiteOverflowed', false)
  }

  handleSelect () {
    this.externalEls?.table?.elements.forEach((tableEl) => {
      if (tableEl.dataset.url === this.externalEls.select.element.value) {
        tableEl.setAttribute('aria-current', true)
      } else {
        tableEl.setAttribute('aria-current', false)
      }
    })
  }

  normalizeTableHeaders () {
    this.externalEls?.table?.elements.forEach((tableEl) => {
      const tables = tableEl.querySelectorAll('table')

      tables.forEach((table) => {
        const headerRow =
          table.querySelector('thead tr') || table.querySelector('tr')

        if (headerRow) {
          headerRow.querySelectorAll('th, td').forEach((cell) => {
            const headerCell = this.getHeaderCell(cell, 'col')

            if (!headerCell.hasAttribute('scope')) {
              headerCell.setAttribute('scope', 'col')
            }
          })
        }

        table.querySelectorAll('tbody tr, tr').forEach((row) => {
          if (row === headerRow) return

          const firstCell = row.querySelector('th, td')
          if (!firstCell) return

          const rowHeaderCell = this.getHeaderCell(firstCell, 'row')

          if (!rowHeaderCell.hasAttribute('scope')) {
            rowHeaderCell.setAttribute('scope', 'row')
          }
        })
      })
    })
  }

  getHeaderCell (cell, defaultScope) {
    if (cell.tagName.toLowerCase() === 'th') {
      return cell
    }

    const headerCell = document.createElement('th')

    Array.from(cell.attributes).forEach((attr) => {
      headerCell.setAttribute(attr.name, attr.value)
    })

    headerCell.innerHTML = cell.innerHTML
    headerCell.setAttribute('scope', defaultScope)
    cell.replaceWith(headerCell)

    return headerCell
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
